/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */
import React from "react";
import { withStyles } from "@mui/styles";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import GenericDialog from "./GenericDialog";
import i18n from "../../services/i18n";

const styles = {
  root: {
    width: 550,
    height: "100%",
    overflowY: "overlay",
    marginBottom: 30,
  },
};

interface Props {
  open: boolean;
  title: string;
  content: string;
  cancelDialogTID?: string;
  confirmDialogTID?: string;
  confirmDialogContentTID?: string;
  list: Array<string>;
  type: string;
  notifyUser: any;
  selectedTool: any;
  confirmCallback: (result: boolean) => void;
  onClose: () => void;
  setNotifyUser: () => any;
}

class ConfirmDialog extends React.Component<Props> {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onConfirm = (result) => {
    this.props.confirmCallback(result);
    this.props.onClose();
  };

  renderTitle = () => {
    return <DialogTitle>{this.props.title}</DialogTitle>;
  };

  renderContent = () => {
    return (
      <DialogContent
      // sx={{ "& .MuiModal-root": { boxShadow: "rgba(100, 100, 111, 0.2) 0px 1px 1px 0px" } }}
      >
        <DialogContentText data-tid={this.props.confirmDialogContentTID}>
          {this.props.content}
          {this.props.list &&
            this.props.list.map((listItem) => (
              <ListItem title={listItem}>
                <Typography variant="inherit" noWrap>
                  {listItem}
                </Typography>
              </ListItem>
            ))}
        </DialogContentText>
        {this.props.type === "notify" ? (
          <FormGroup sx={{ display: this.props?.selectedTool?.status ? "none" : "block" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.props.notifyUser}
                  onChange={() => this.props.setNotifyUser(!this.props.notifyUser)}
                  name="inform user"
                />
              }
              label="Notify user"
            />
          </FormGroup>
        ) : null}
      </DialogContent>
    );
  };

  renderActions = () => {
    return (
      <DialogActions
        sx={{ display: "flex", justifyContent: "space-between", padding: "10px 24px 16px 24px" }}
        // sx={{ margin: "0vh 2vh" }}
      >
        <Button
          onClick={() => this.onConfirm(false)}
          // color="primary"
          variant="contained"
          data-tid={this.props.cancelDialogTID}
          sx={{
            backgroundColor: "gray",
            borderRadius: "0px",
            "&:hover": { backgroundColor: "#656464" },
          }}
        >
          {i18n.t("core:no")}
        </Button>
        <Button
          data-tid={this.props.confirmDialogTID}
          onClick={() => this.onConfirm(true)}
          color="primary"
          variant="contained"
          sx={{
            backgroundColor: "#147AAE",
            borderRadius: "0px",
            "&:hover": { backgroundColor: "#0b98cf" },
          }}
        >
          {i18n.t("core:yes")}
        </Button>
      </DialogActions>
    );
  };

  render() {
    return (
      <GenericDialog
        open={this.props.open}
        onClose={this.props.onClose}
        renderTitle={this.renderTitle}
        renderContent={this.renderContent}
        renderActions={this.renderActions}
      />
    );
  }
}

ConfirmDialog.defaultProps = {
  cancelDialogTID: "confirmDialogCancelButton",
  confirmDialogTID: "confirmDialogOkButton",
  confirmDialogContentTID: "confirmDialogContentTID",
};

export default withStyles(styles)(ConfirmDialog);
